/*
 * The app languages, with no catalogue import, so a consumer that needs only the
 * list (for example an admin filter) does not load the English messages.
 */

export const SUPPORTED_LANGUAGES = [
  'cs',
  'de',
  'en',
  'es',
  'fr',
  'hr',
  'hu',
  'it',
  'ja',
  'ko',
  'nl',
  'pl',
  'pt',
  'ro',
  'ru',
  'sl',
  'th',
  'tr',
  'uk',
  'zh',
] as const

export type Language = (typeof SUPPORTED_LANGUAGES)[number]

export const isSupportedLanguage = (value: string): value is Language =>
  (SUPPORTED_LANGUAGES as readonly string[]).includes(value)
